import React from 'react';

import get from 'lodash/get';

import { DescriptionList, DescriptionItem } from '@gogame/components';

import DateRangeWithConstants from './DateRangeWithConstants';
import DisplayDays from './DisplayDays';

export const NON_DEPOSITORS = 0;
export const REGULAR = 1;
export const SUBSCRIBERS = 2;

export default ({ data }) => {
  const audienceTypes = get(data, 'audienceTypes', []);
  const isAll =
    audienceTypes.includes(NON_DEPOSITORS) &&
    audienceTypes.includes(REGULAR) &&
    audienceTypes.includes(SUBSCRIBERS);

  if (isAll) {
    return null;
  }
  const topDepositors = get(data, 'depositor.topDepositors', {});

  return (
    <DescriptionList disableGutters data={data}>
      <DescriptionItem
        label={'Last deposit period'}
        type={({ value }) => <DateRangeWithConstants period={value} />}
        field={'depositor.depositPeriod'}
      />
      <DescriptionItem
        label={'Days to deposit'}
        type={({ value }) => <DisplayDays value={value} />}
        field={'depositor.daysToDeposit'}
      />
      <DescriptionItem
        label={'Days since last deposit'}
        type={({ value }) => <DisplayDays value={value} />}
        field={'depositor.daysSinceLastDepositFrom'}
      />
      <DescriptionItem
        label={'Deposit amount'}
        type={'currencyRange'}
        field={'depositor.depositAmount'}
        valueParser={'minMaxToStringArray'}
      />
      <DescriptionItem
        label={'Deposit count'}
        field={'depositor.depositsCount'}
        type={'decimalRange'}
        valueParser={'minMaxToStringArray'}
      />
      {topDepositors.type === 'number' ? (
        <DescriptionItem
          label={'TOP depositors only'}
          field={'depositor.topDepositors.value'}
          type={'decimal'}
        />
      ) : null}
      {topDepositors.type === 'percent' ? (
        <DescriptionItem
          label={'TOP depositors only'}
          field={'depositor.topDepositors.value'}
          type={'percent'}
        />
      ) : null}
    </DescriptionList>
  );
};
